var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 56.293,
    viewBox: "0 0 122 56.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M206.583,10.418a5.477,5.477,0,0,0,5.711-5.209,5.735,5.735,0,0,0-11.422,0A5.477,5.477,0,0,0,206.583,10.418Z",
    transform: "translate(-147.34)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M425.145,136.1c0-3.389-2.452-5.393-5.9-5.393-3.515,0-5.962,2.008-5.962,5.393s2.452,5.393,5.962,5.393C422.7,141.5,425.145,139.493,425.145,136.1Z",
    transform: "translate(-303.145 -95.877)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M32.194,34.865c0-6.276-3.891-9.853-9.414-11.865-1.381-.565-4.581-1.694-6.464-2.452-1.945-.753-4.393-1.757-4.393-4.393s2.385-3.891,5.648-3.891,7.154,1.891,9.665,4.4l4.33-7.091c-2.95-2.95-8.727-5.334-13.744-5.334S8.848,5.62,6.4,7.691a12.2,12.2,0,0,0-4.518,9.476,10.688,10.688,0,0,0,3.389,8.347,16.916,16.916,0,0,0,5.146,3.138c1.443.628,4.707,1.757,6.589,2.452s5.083,1.82,5.083,4.77c0,2.887-2.51,4.456-5.774,4.456-3.326,0-8.159-2.2-11.3-5.46L0,42.271C3.515,45.534,9.1,48.8,15.372,48.8,23.785,48.8,32.194,44.22,32.194,34.865Z",
    transform: "translate(0 -3.11)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M149.686,49.426V6.123H139.645v43.3Z",
    transform: "translate(-102.43 -4.491)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M213.5,83.45V52.51H203.463V83.45Z",
    transform: "translate(-149.241 -38.516)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M301.5,66.429c0-9.1-5.648-16.066-14.56-16.066a12.773,12.773,0,0,0-10.3,4.518h-.126l.063-3.954h-9.534v42.3h10.041V77.977c1.945,2.887,5.209,4.577,9.79,4.577C295.852,82.554,301.5,75.529,301.5,66.429ZM291.267,66.3c0,4.77-2.95,8.033-7.28,8.033-4.267,0-7.217-3.263-7.217-8.033s2.95-8.033,7.217-8.033c4.339,0,7.28,3.264,7.28,8.033Z",
    transform: "translate(-195.88 -36.934)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ad1909116d36aed9b3de6d9d1e1ca4d0.svg";
export { ForwardRef as ReactComponent };